module.exports = __webpack_public_path__ + "static/media/emailNotifications.aaddf1d9.svg";